import { makeStyles } from "@material-ui/styles";
// import loginBG from "../../images/loginBG.jpg";

export default makeStyles((theme) => ({
  iconsContainer: {
    width: "60%",
  },
  serviceIconContainer: {
    width: 150,
    height: 200,
    borderRadius: 10,
    border: "0.7px solid gray",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    padding: 10,
    cursor: "pointer",
    background: "rgba(255,255,255,0.7)",
  },
  item: {
    "& :hover": {
      background: "#fff",
      transform: "scale(1.1)",
    },
  },
  serviceIconLogo: {
    width: "80%",
    height: "auto",
  },
  serviceIconTitle: {
    textAlign: "center",
    fontWeight: "bold",
  },
  serviceIconDescription: {
    textAlign: "center",
  },
}));
